<template>
  <div class="dept-item">
    <div class="dept-name">
      <span>{{data.deptName}}</span>
    </div>
    <div class="dept-desc">
      <span>{{data.remark}}</span>
    </div>
    <div class="dept-time">
      <span>{{data.createTimeStr}}</span>
    </div>
    <div class="dept-operate">
      <el-tooltip effect="dark" content="新建" placement="top">
        <button type="button" @click="appendClick" class="btn btn-link btn-xs"><i class="fa fa-plus"></i></button>
      </el-tooltip>
      <el-tooltip effect="dark" content="编辑" placement="top">
        <button type="button" @click="editClick" class="btn btn-link btn-xs"><i class="fa fa-edit"></i></button>
      </el-tooltip>
      <el-popover placement="top">
        <slot>
          <div style="text-align: right; margin: 0">
            <span :style="{'color': '@font-color-base'}">是否删除该部门?</span><br><br>
            <el-button type="text" size="mini" @click="handleClosePopover($event)">取消</el-button>
            <el-button class="btn-primary" size="mini" @click.native.prevent="removeClick">确定</el-button>
          </div>
        </slot>
        <el-tooltip slot="reference" effect="dark" content="删除" placement="top">
          <button type="button" class="btn btn-link btn-xs"><i class="fa fa-remove"></i></button>
        </el-tooltip>
      </el-popover>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'DeptItem',
    props: {
      data: {
        type: Object
      },
      appendClick: {
        type: Function
      },
      removeClick: {
        type: Function
      },
      editClick: {
        type: Function
      }
    },
    methods: {
      handleClosePopover(event){
        $(event.target).parents('body').trigger('click')
      },
    }
  }
</script>
<style lang='less'>
.deptMng .el-tree-node__content{
  display: flex;
  flex-flow: row;
  width: 100%;
  align-items: center;
}
.dept-item{
  display: table;
  width: 100%;
  .dept-name{
    display: table-cell;
  }
  .dept-desc{
    display: table-cell;
    width: 200px;
  }
  .dept-operate{
    width: 120px;
      display: table-cell;
  }
  .dept-time{
    width: 180px;
    display: table-cell;
  }

}
</style>
